import type { Feature } from './feature'
import * as models from './models'

export class Selectors {
  /**
   * {@link models.Employee} information about currently logged user
   */
  public readonly currentEmployee

  /**
   * ID of the {@link currentEmployee}
   */
  public readonly currentEmployeeId

  /**
   * Whether or not we are currently retrieving data about the currently logged
   * in user as an employee
   */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isLoading

  /**
   * The error that occurred while trying to retrieve data about the currently
   * logged in user
   */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly error

  constructor(feature: Feature) {
    const employeeInfo = feature.state.project(state => state.employee)

    this.currentEmployee = employeeInfo.project(info => info?.data)
    this.currentEmployeeId = this.currentEmployee.project(
      employee => employee?.id,
    )

    this.error = employeeInfo.project(info => info?.error)
    this.isLoading = employeeInfo.project(info => info?.isLoading)
  }
}
